module.exports = __webpack_public_path__ + "img/backtop.d1328d97.svg";